import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { RingLoader } from 'react-spinners';
import styled from 'styled-components';

interface StyledLoaderProps {
  $size: number;
  $color: string;
  $shadowColor: string;
}

const ShadowOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: black;
  opacity: 0.4;
`;

const LoaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
`;

const Loader = styled.div<StyledLoaderProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 10%;
  width: auto;
  padding: 15px;
  border-radius: 10px;

  .loaderText {
    font-size: ${props => props.$size}px;
    margin-top: ${props => props.$size / 3}px;
    margin-left: ${props => props.$size / 4 + 15}px;
    color: ${props => props.$color};
    text-shadow: 1px 1px 5px ${props => props.$shadowColor};
  }
`;

export const ContentContainer = styled.div`
  position: relative;
  box-sizing: border-box;
`;

interface Props {
  title?: string;
  iconSize?: number;
  textSize?: number;
  iconColor?: string;
  textColor?: string;
  textShadowColor?: string;
}

const ContentLoader: React.FC<Props & WithTranslation> = props => {
  const iconSize = props.iconSize || 48;
  const textSize = props.textSize || iconSize / 2;
  const title = props.title || props.t('loading_entries') + '...';
  const iconColor = props.iconColor || 'white';
  const textColor = props.textColor || 'white';
  const textShadowColor = props.textShadowColor || 'black';

  return (
    <>
      <ShadowOverlay />
      <LoaderOverlay>
        <Loader className="content loader" $size={textSize} $color={textColor} $shadowColor={textShadowColor}>
          <RingLoader size={iconSize} color={iconColor} /> <span className="loaderText">{title}</span>
        </Loader>
      </LoaderOverlay>
    </>
  );
};

export default withTranslation()(ContentLoader);
